import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

import ExternalButton from './button';

const SocialNetworks = ({
  action,
  styles,
  onAuthResponse,
  onAuthInit,
  createAccount,
  acceptTerms,
  newsLetter,
}) => {
  const { market, t } = useContext(AppContext);
  return (
    market.socialNetworks &&
    market.socialNetworks.map(service => (
      <div key={service} className={styles.spacer}>
        <ExternalButton
          service={service}
          text={t('account', `${service}.${action}-button`)}
          onAuth={onAuthResponse}
          onInit={onAuthInit}
          createAccount={createAccount}
          acceptTerms={acceptTerms}
          newsLetter={newsLetter}
        />
      </div>
    ))
  );
};

SocialNetworks.propTypes = {
  action: PropTypes.oneOf(['login', 'signup']).isRequired,
  styles: PropTypes.shape({
    spacer: PropTypes.string.isRequired,
  }).isRequired,
  onAuthResponse: PropTypes.func.isRequired,
  onAuthInit: PropTypes.func.isRequired,
  createAccount: PropTypes.bool,
  acceptTerms: PropTypes.bool,
  newsLetter: PropTypes.bool,
};

SocialNetworks.defaultProps = {
  createAccount: false,
  acceptTerms: false,
  newsLetter: false,
};

export default memo(SocialNetworks);
